import { useCallback, useState, useMemo } from "react";
import moment from "moment-timezone";

const useAcSelectDate = (defaultDates, format = "YYYY-MM-DD", defaultIsTimezoneAware = true) => {
  const timezone = moment.defaultZone ? moment.defaultZone.name : moment.tz.guess();
  const currentDateInTimezone = moment().tz(timezone).format("YYYY-MM-DD");
  const today = useMemo(() => moment.utc(currentDateInTimezone), [currentDateInTimezone]);

  const [dates, setDates] = useState(() => {
    if (!defaultDates) {
      return {
        from: defaultIsTimezoneAware ? today.unix() : moment.utc().unix(),
        to: defaultIsTimezoneAware ? today.unix() : moment.utc().unix(),
      };
    }
    return defaultDates;
  });

  const handleDateChange = useCallback((dates) => {
    setDates(dates);
  }, []);

  const formatDates = useMemo(() => {
    return {
      from: moment.unix(dates.from).utc().format(format),
      to: moment.unix(dates.to).utc().format(format),
    };
  }, [format, dates]);

  return {
    dates,
    formatDates,
    handleDateChange,
    today,
  };
};

export default useAcSelectDate;
